import React, { lazy, Suspense, useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import WarehousePage from '../components/common/page/WarehousePage'
import PageLoading from '../components/common/spinners/PageLoading'
import { Route, Routes } from 'react-router-dom'
import NotFound from '../pages/not-found/NotFound '

const Warehouse = () => {
    let isAuthenticated = false
    const [pageHead, setPageHead] = useState({ title: null, desc: null })
    const rfs_tkn = Cookies.get('_rfs_tkn');
    const DVC_ID = Cookies.get('DVC_ID');

    const PendingList = lazy(() => import('../pages/warehouse/pending-list/PendingList'))
    const ViewWarehouseItem = lazy(() => import('../pages/warehouse/view-item/ViewWarehouseItem'))
    const History = lazy(() => import('../pages/warehouse/history/History'))

    if (DVC_ID && rfs_tkn) {
        isAuthenticated = true
    }

    useEffect(() => {
        // Change Title
        document.title = `Warehouse | Sales App | Alliance`;

        // eslint-disable-next-line
    }, [])


    return (
        <WarehousePage pageHead={pageHead}>
            <Suspense fallback={<PageLoading />}>
                <Routes>
                    {/* Pending */}
                    <Route path='/' element={<PrivateRoute element={<PendingList setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/item/:prospect_id' element={<PrivateRoute element={<ViewWarehouseItem setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* History */}
                    <Route path='/history' element={<PrivateRoute element={<History setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    <Route path="/*" element={<NotFound setPageHead={setPageHead} />} />
                </Routes>
            </Suspense>
        </WarehousePage>
    )
}

export default Warehouse

function PrivateRoute({ element, isAuthenticated, }) {
    return isAuthenticated ? element : window.location.href = 'https://staff.alliancewatersolutions.com/?page=home';
}